import React, { useState,useEffect, useCallback, useRef} from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import axios from "axios";
import { useRouter } from "next/router";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { ENDPOINTS } from "@/config/endpoints";
import Image from "next/image";
import IMAGES from "@/public/assets/img";
import { ColorRing } from 'react-loader-spinner';
import { sendOTPForTermsheet, verifyOTPForTermsheet } from '@/lib/credlixBypass';
import { pushCleverTapEvent } from "../pushCleverTapEvent";

const schema = () => {
  return yup.object({
    Name: yup.string().required("This field is required."),
    Email: yup
      .string()
      .required("This field is required.")
      .email("Email is not valid"),
    Phone: yup
      .string()
      .matches(/^\d{10}$/, "Phone number must be 10 digits")
      .test(
        "not-starting-with-0-1-2-3",
        "Phone number must not start with 0,1, 2, 3",
        (value) => value && !/^[0123]/.test(value)
      ),
    Company: yup.string().required("This field is required."),
  });
};

const PartnerProgramForm = () => {
  const validationSchema = schema();
  const [ThankyouRes, setThankyouRes] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [errMSG, setErrMSG] = useState(false);
  const [phVerifiedCfForm, setPhVerifiedCfForm] = useState(false);
  const [otpBtnDisabled, setOtpBtnDisabled] = useState(true);
  const [phoneErrorMsg, setPhoneErrorMsg] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showOtpField, setShowOtpField] = useState(false);
  const [networkErrorCfForm, setNetworkErrorCfForm] = useState(false);
  const [getOtp, setGetOtp] = useState(false);
  const router = useRouter();
  const [otpIncorrect, setOtpIncorrect] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const [otpNumericIncorrect, setOtpNumericIncorrect] = useState(false);
  const [requestIdCfForm, setRequestIdCfForm] = useState('');
  const [phoneNumberCfForm, setPhoneNumberCfForm] = useState('');
  const [responseOfOTP, setResponseOfOTP] = useState(false);
  const [allFieldsError, setAllFieldsError] = useState(false);
  const { locale } = router;
  // const t = locale === 'en' ? en : es;
  const [otpResponsePartner, setOtpResponsePartner] = useState(false);
  const eventTriggeredRef = useRef(false);
  const [group, setGroup] = useState(null);
  const pageName = process.env.URL + router.asPath;
  const {
    register,
    handleSubmit,
    formState: { isValid, errors },
  } = useForm({
    mode: "all",
    resolver: yupResolver(validationSchema),
  });

  const trackEventClick = () => {
            pushCleverTapEvent("Partner_Form_Start", { "PageName": 'Partnership_Page' });
  };

  const handleCaptchaSubmitCfForm = useCallback(async () => {
    if (!executeRecaptcha) {
        return false;
    }

    try {
        const gReCaptchaToken = await executeRecaptcha();
        return gReCaptchaToken
    } catch (error) {
        console.error('Error executing reCaptcha:', error);
    }
}, [executeRecaptcha]);

  const checkPhoneCfForm = (e) => {
    const value = e.target.value;
    const regex = /^[0-9]*$/;

    // setOtpBtnDisabled(false);

    if (value !== '' && value.length == 10 && regex.test(value)) {
        setOtpBtnDisabled(false);
        setShowOtpField(false);
        setPhoneNumberCfForm(value);
        setPhoneErrorMsg(false);
        setPhVerifiedCfForm(false);
    } else {
        setPhVerifiedCfForm(false);
        setPhoneErrorMsg(true);
        setOtpBtnDisabled(true);
    }
    setPhoneNumberCfForm(value);
};

  const sendOTPCfForm = async () => {

    const captchaToken = await handleCaptchaSubmitCfForm();

    setLoader(true);
    setShowOtpField(true);


    try {
        const response = await sendOTPForTermsheet(phoneNumberCfForm, captchaToken);
        const res = await response.json();

        if (response.status == 200) {
            const result = res.result.requestId;
            setGetOtp(true)
            setRequestIdCfForm(result);
            // updateData('Phone', phoneNumber)
        } else {
            console.error('Error sending OTP:', response.statusText);
        }
    } catch (error) {
        startCountdownCfForm();
    } finally {
        startCountdownCfForm();
    }


};
const startCountdownCfForm = () => {
  setCountdown(30);
  // setOtpBtnDisabled(true);

  const countdownInterval = setInterval(() => {
      setCountdown((prevCountdown) => {
          const newCountdown = prevCountdown - 1;
          if (newCountdown === 0) {
              clearInterval(countdownInterval);
              setOtpBtnDisabled(false);

          } else {
              setLoader(false);
          }

          return newCountdown >= 0 ? newCountdown : 0;
      });


  }, 500);
};
const verifyPhoneNumberCfForm = () => {
  const enteredOTP = Array.from({ length: 6 }, (_, index) =>
      document.getElementById(`digit${index + 1}`).value
  ).join('');
  if (!/^\d+$/.test(enteredOTP)) {
      setOtpNumericIncorrect(true);
  } else {
      // Check if enteredOTP is a 6-digit number
      if (enteredOTP.length === 6) {
          setOtpNumericIncorrect(false); // Reset incorrect OTP state
          setGetOtp(false);
          setLoader(false);
          verifyOTPCfForm(enteredOTP);
      } else {
          setOtpNumericIncorrect(true);
      }
  }
}
const verifyOTPCfForm = async (enteredOtp) => {

  const captchaToken = await handleCaptchaSubmitCfForm();
  setLoader(true);
  setShowOtpField(true)
  try {
      const response = await verifyOTPForTermsheet(requestIdCfForm, enteredOtp, captchaToken);
      if (response.status == 200) {
        setOtpResponsePartner(true)
          const result = response.data;
          setPhVerifiedCfForm(true);
          setGetOtp(false)
          setLoader(false)
          setShowOtpField(false)
          setNetworkErrorCfForm(false)
          setResponseOfOTP(true);
          setOtpBtnDisabled(true);
          window.gtag('event', 'Partner_OTP_verified', {
            'event_category': 'Partner_OTP_verified',
            'event_label': 'Partner OTP'
          });
          pushCleverTapEvent("Partner_OTP_Submit", { "PageName": 'Partnership_Page', "Phone": phoneNumberCfForm,});
          // if (phVerifiedCfForm) {
          //     setOtpBtnDisabled(true)
          // }
      } else {
          setOtpIncorrect(true);
          setPhVerifiedCfForm(false);
          setOtpResponsePartner(false)
      }

  } catch (error) {
      setOtpIncorrect(true);
      setNetworkErrorCfForm(true)
      console.error('verifyOTPCfForm :: Error verifying OTP:', error);
  }
};
const moveToNextInputCfForm = (currentInput, nextInputId) => {
  let maxLength = parseInt(currentInput.getAttribute('maxLength'));
  let currentLength = currentInput.value.length;

  if (currentLength === maxLength) {
      document.getElementById(nextInputId).focus();
  }
  verifyPhoneNumberCfForm()
}

useEffect(() => {
  if (phVerifiedCfForm) {
      setOtpBtnDisabled(true)
  }
  const storedGroup = localStorage.getItem('credlixTraffic');
  setGroup(storedGroup);
}, [phVerifiedCfForm, otpBtnDisabled,otpResponsePartner]);

  const handleCaptchaSubmit = useCallback(
    (values) => {
      if (!executeRecaptcha) {
        return false;
      }
      executeRecaptcha("enquiryFormSubmit").then((gReCaptchaToken) => {
        onFormSubmit({...values,otpResponsePartner}, gReCaptchaToken);
      });
    },
    [executeRecaptcha,otpResponsePartner]
  );

  async function onFormSubmit(values,gReCaptchaToken) {
    if(values.Email && values.Phone && values.Name && values.Company && values.otpResponsePartner){
     setAllFieldsError(false);
    const body = {
      formType: "PartnerProgram",
      name: values.Name,
      email: values.Email,
      phoneNumber: values.Phone,
      company: values.Company,
      country: "India",
      countryCode: "+91",
      sourceUrl: window.location.href,
    };
    let config = {
      method: "post",
      url: ENDPOINTS.PARTNER_PROGRAM,
      headers: {
        "Content-Type": "application/json",
        "g-recaptcha-response": gReCaptchaToken,
      },
      data: body,
    };
    try {
      const response = await axios(config);
      if (response.status == 200) {
        gtag('event', 'Partner_Submit_success', {
          'event_category': 'Partner_Submit_success',
          'event_label': 'Partner Domestic'
      });
        pushCleverTapEvent("Partner_Form_Submit", { "PageName": 'Partnership_Page', ...body });
      window.dataLayer.push({
        event: "Partner_Program_Page_Submit_form",
        Conversion_ID: "16468312892",
        Conversion_labels: "TYSxCLKU9ZUaELyG2qw9",
      });
        setThankyouRes(true);
        setTimeout(() => {
          setThankyouRes(false);
          router.push("/thankyou-response");
        }, 3000);
      }
    } catch (err) {
      setErrMSG(true);
      console.log("error", err);
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
  }
  else {
    setAllFieldsError(true); 
  }
 }
  return (
    <div className="sm:w-full my-14 sm:my-6 sm:px-3">
        <div className="bg-white sm:mt-2 shadow-icon-btn-shadow rounded-[8px] py-5 px-3 sm:px-[16px] lg:w-full lg:max-w-[370px] md:max-w-[370px] sm:w-[100%] ml-auto md:relative md:m-auto border-#FFFFFF">
         <Image src={IMAGES?.partnerProgram?.tenxFaster} width={325} height={56} alt="Tenx Faster"/>
          <form
            onSubmit={handleSubmit(handleCaptchaSubmit)}
            // onSubmit={handleSubmit(onFormSubmit)}
          >
            <div className="pt-5">
              <input
                name="Name"
                type="text"
                id="name"
                placeholder="Full Name*"
                className="block w-full appearance-none rounded-md border border-bordercolor px-3 py-1 placeholder-gray-400 text-sm font-normal"
                {...register("Name")}
                onClick={trackEventClick}
              />
              <p className="text-progressColor4 text-xs mt-[3px]">
                {errors.Name?.message}
              </p>
            </div>
            <div className="pt-2">
              <input
                {...register("Email")}
                id="email"
                type="email"
                placeholder="Email*"
                className="block w-full appearance-none rounded-md border border-bordercolor px-3 py-1 placeholder-gray-400 text-sm font-normal"
              />
              <p className="text-progressColor4 text-xs mt-[3px]">
                {errors.Email?.message}
              </p>
            </div>
            <div className="pt-2">
            <div className=' flex relative'>
              <input
               placeholder="Mobile number*"
               className="block w-full appearance-none rounded-md border border-bordercolor px-3 py-1 placeholder-gray-400 text-sm font-normal"
               {...register("Phone")}
               onChange={checkPhoneCfForm}
               id="tel"
               type="tel"
               maxLength={10}
              />
                {phVerifiedCfForm &&
                            <div className="absolute flex items-center top-[7px] right-[90px] sm:right-[85px] z-10 bg-[#E0FDDF] px-2 sm:px-1 text-xs text-[#299E22] h-[30px] rounded-md">
                                <span className='items-center flex'>
                                    <svg className='mr-[5px] ' xmlns="https://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24" width="13" height="13">
                                        <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z" fill="rgba(41,158,34,1)">
                                        </path>
                                    </svg>
                                    Verified
                                </span>

                            </div>
                        }
                        <button type='button' disabled={otpBtnDisabled} onClick={sendOTPCfForm} className={`top-0 bottom-0 absolute right-0 rounded-r-md text-xs text-center px-1 w-[81px] disabled:bg-[#ddd] disabled:text-[#888] disabled:cursor-not-allowed bg-yellowcolor text-black`}>
                            {loader ?
                                (<ColorRing
                                    visible={true}
                                    height="30"
                                    width="30"
                                    ariaLabel="blocks-loading"
                                    wrapperClass="ringForOtp"
                                    colors={['#000']}
                                />
                                ) :
                                "Send OTP"
                            }
                        </button>
           </div>
           {networkErrorCfForm &&
                        <div className='text-progressColor4 text-xs mt-[3px]'>Invalid captcha</div>
                    }
                    {phoneErrorMsg &&
                        <div className='text-progressColor4 text-xs mt-[3px]'>Please fill this with valid phone number.</div>
                    }
                    <div className='flex justify-end'>
                        {getOtp && (
                            <div className='flex justify-end text-sm mt-1'>
                                <span className='text-sm text-brand mr-[5px]'>Didn't get OTP?{' '}</span> Resend in {countdown}s</div>
                        )}
                    </div>
            </div>
            {showOtpField &&
                    <>
                        <label className='text-sm font-medium text-secondary mb-0 mt-2 block' htmlFor="digit1">Enter OTP</label>
                        <div className='flex flex-wrap justify-between mt-[5px]'>
                            <input className='h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[50px] sm:w-[40px]' type="text" id="digit1" onChange={(e) => { verifyPhoneNumberCfForm, moveToNextInputCfForm(e.target, 'digit2') }} maxLength="1" pattern="[0-9]" required />
                            <input className='h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[50px] sm:w-[40px]' type="text" id="digit2" onChange={(e) => { verifyPhoneNumberCfForm, moveToNextInputCfForm(e.target, 'digit3') }} maxLength="1" pattern="[0-9]" required />
                            <input className='h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[50px] sm:w-[40px]' type="text" id="digit3" onChange={(e) => { verifyPhoneNumberCfForm, moveToNextInputCfForm(e.target, 'digit4') }} maxLength="1" pattern="[0-9]" required />
                            <input className='h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[50px] sm:w-[40px]' type="text" id="digit4" onChange={(e) => { verifyPhoneNumberCfForm, moveToNextInputCfForm(e.target, 'digit5') }} maxLength="1" pattern="[0-9]" required />
                            <input className='h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[50px] sm:w-[40px]' type="text" id="digit5" onChange={(e) => { verifyPhoneNumberCfForm, moveToNextInputCfForm(e.target, 'digit6') }} maxLength="1" pattern="[0-9]" required />
                            <input className='h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[50px] sm:w-[40px]' type="text" id="digit6" onChange={verifyPhoneNumberCfForm} maxLength="1" pattern="[0-9]" required />
                        </div>
                        {otpNumericIncorrect && <div className='text-progressColor4 text-xs mt-[3px]'>Incorrect OTP</div>}
                        {otpIncorrect && <div className='text-progressColor4 text-xs mt-[3px]'>Please enter correct OTP</div>}
                    </>
                }
            <div className="pt-2">
              <input
                name="Company"
                type="text"
                id="company"
                placeholder="Company*"
                className="block w-full appearance-none rounded-md border border-bordercolor px-3 py-1 placeholder-gray-400 text-sm font-normal"
                {...register("Company")}
              />
              <p className="text-progressColor4 text-xs mt-[3px]">
                {errors.Company?.message}
              </p>
            </div>
            <div className="mt-4">
                <button
                  className="py-1 px-3 rounded-md text-white text-lg font-normal w-full bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]"
                  type="submit"
                >
                 Apply Now
                </button>
              </div>
              {allFieldsError  && !otpResponsePartner &&
               <p className='text-progressColor4 text-xs mt-[3px]'>Please fill in all required fields and send otp to verify your number if not.</p>
              }
          </form>
        {errMSG ?
        <div className='text-[red] text-center' >
          <p className='text-sm font-medium mt-3'>
          There is some server response error.
          </p>
        </div>
        : null}
          {ThankyouRes ? (
            <>
              <div className="text-green text-center">
                <p className="text-sm font-medium mt-3">
                  Successfull Submission : Thank you for your interest.{" "}
                </p>
              </div>
            </>
          ) : null}
        </div>
      </div>
  );
};

export default PartnerProgramForm;
